import { GESTION_OPERATIVA_SET_FEES } from './constants'

export function setFees(fees) {
  return (dispatch, getState) => {

    const { gestionOperativa } = getState();

    dispatch({
      type: GESTION_OPERATIVA_SET_FEES,
      data: {
        sale: {
            ...gestionOperativa.sale,
            fees_number: fees,
            credit_line_fees: fees,
        },
      },
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_FEES) {
      return {
        ...state,
        sale: {
            ...state.sale,
            fees_number: action.data.sale.credit_line_fees,
            credit_line_fees: action.data.sale.credit_line_fees,
        }
      }
  }
  else {
    return state
  }    
}
